import { LazyMapsAPILoaderConfigLiteral } from '@agm/core';
import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';

const getRandomApiKey = (keys: string[]): string => {
  return (keys.length > 0) ? keys[Math.floor(Math.random() * keys.length)] : null;
};

@Injectable()
export class GoogleMapsConfig implements LazyMapsAPILoaderConfigLiteral {
  apiKey: string;
  constructor() {
    const apiKeys = JSON.parse(environment.GOOGLE_API_KEYS);

    this.apiKey = getRandomApiKey(apiKeys);
  }
}



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/core/config/google-maps-config.ts